/*
 * Beechifa — resynchronisation d'un bloc au changement de variante.
 *
 * Sur la fiche produit, Horizon ne remorphe que le <variant-picker> lui-meme
 * (assets/variant-picker.js, fetchUpdatedSection sans morphElementSelector).
 * Le reste de la page ne bouge pas : chaque bloc dependant de la variante doit
 * ecouter l'evenement variant:update, comme le font product-price.js et
 * product-sku.js. L'evenement transporte dans detail.data.html le document
 * complet re-rendu par Shopify pour la variante choisie : on y retrouve le
 * meme bloc, deja calcule par Liquid, et on recopie son contenu.
 *
 * Aucune logique metier n'est dupliquee ici : la source de verite reste le
 * Liquid du bloc.
 */
class BeechifaVariantSync extends HTMLElement {
  connectedCallback() {
    this.scope = this.closest('.shopify-section, dialog');
    if (!this.scope) return;
    this.scope.addEventListener('variant:update', this.resync);
  }

  disconnectedCallback() {
    if (this.scope) this.scope.removeEventListener('variant:update', this.resync);
  }

  resync = (event) => {
    const doc = event && event.detail && event.detail.data && event.detail.data.html;
    const id = this.dataset.blockId;
    if (!doc || !id) return;

    const frais = doc.querySelector('beechifa-variant-sync[data-block-id="' + id + '"]');
    if (!frais || frais.innerHTML === this.innerHTML) return;

    this.innerHTML = frais.innerHTML;
  };
}

if (!customElements.get('beechifa-variant-sync')) {
  customElements.define('beechifa-variant-sync', BeechifaVariantSync);
}
